export const UPDATE_THEME = "UPDATE_THEME";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const SET_MESSAGE = "SET_MESSAGE";

export const UPDATE_LOADING = "UPDATE_LOADING";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";

export const UPDATE_CREDENTIALS = "UPDATE_CREDENTIALS";
export const UPDATE_CONTACT_DATA = "UPDATE_CONTACT_DATA";

export const UPDATE_LEGALE_PAGES = "UPDATE_LEGALE_PAGES";
export const UPDATE_USERS = "UPDATE_USERS";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_LEGALE_USER = "UPDATE_LEGALE_USER";

export const UPDATE_EXPLORER_FOLDERS = "UPDATE_EXPLORER_FOLDERS";
export const UPDATE_EXPLORER_CURRENT_FOLDER = "UPDATE_EXPLORER_CURRENT_FOLDER";
export const UPDATE_EXPLORER_FILTER = "UPDATE_EXPLORER_FILTER";
export const UPDATE_EXPLORER_FILES = "UPDATE_EXPLORER_FILES";
export const UPDATE_EXPLORER_SELECTED_FILE = "UPDATE_EXPLORER_SELECTED_FILE";
export const UPDATE_EXPLORER_SELECTED_FILES = "UPDATE_EXPLORER_SELECTED_FILES";
export const UPDATE_FILTERED_FILES = "UPDATE_FILTERED_FILES";
export const UPDATE_SIGN_PROCESSING = "UPDATE_SIGN_PROCESSING";

export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_SOCKET_NOTIFICATION = "UPDATE_SOCKET_NOTIFICATION";
export const UPDATE_SOCKET_TOKEN = "UPDATE_SOCKET_TOKEN";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const CLOSE_SIGN_INPUT_MODAL = "CLOSE_SIGN_INPUT_MODAL";
export const RESET_CLOSE_SIGN_INPUT_MODAL = "RESET_CLOSE_SIGN_INPUT_MODAL";
export const UPDATE_COMPLETED_SIGN_CNT = "UPDATE_COMPLETED_SIGN_CNT";

export const UPDATE_TICKET_CATEGORIES = "UPDATE_TICKET_CATEGORIES";
export const UPDATE_SMART_TEMPLATES = "UPDATE_SMART_TEMPLATES";